export const MOBILE_REGEX_BD = /(^(\+8801|8801|01|008801))[1|3-9]{1}(\d){8}$/;
